import DashboardLayout from 'src/components/Dashboard/Layout/DashboardLayout.vue'

const Index = () => import(/* webpackChunkName: "admin/events" */ './Index')
const Form = () => import(/* webpackChunkName: "admin/events" */ './Form')

export default [
  {
    path: 'events',
    name: 'events-index',
    component: Index,
    meta: {
      auth: true,
      // breadcrumb: function () {
      //   return this.$gettext('Events')
      // }
    },
    children: [
      {
        path: 'add',
        name: 'events-add',
        component: Form,
        meta: {
          auth: true,
          // breadcrumb: function () {
          //   return this.$gettext('Add event')
          // }
        }
      },
      {
        path: ':id/edit',
        name: 'events-edit',
        component: Form,
        meta: {
          auth: true,
          // breadcrumb: function () {
          //   return this.$gettext('Edit event')
          // }
        }
      }
    ]
  },

]
